import { Trash } from "@phosphor-icons/react";
import { useState } from "react";

import { Button } from "common/components/ui/Button";
import {
  Dialog,
  DialogContent,
  DialogTrigger,
} from "common/components/ui/Dialog";

import RemoveTargets from "../../../ManageAudience/RemoveTargets";

import type { AudienceFilters, AudienceProfile } from "../../../../../types";

interface RemoveAudienceDialogProps {
  selectedProfiles: AudienceProfile[];
  onSuccess: () => void;
  filters?: AudienceFilters;
}

export default function RemoveAudienceDialog({
  selectedProfiles,
  onSuccess,
  filters,
}: RemoveAudienceDialogProps) {
  const [isOpen, setIsOpen] = useState(false);

  const eligibleCount = selectedProfiles.filter(
    ({ state }) => state !== "done" && state !== "cancelled",
  ).length;

  if (!eligibleCount) {
    return null;
  }

  const suffix = eligibleCount > 1 ? "s" : "";

  function onRemoveSuccess() {
    onSuccess();
    setIsOpen(false);
  }

  return (
    <Dialog open={isOpen} onOpenChange={setIsOpen}>
      <DialogTrigger asChild>
        <Button leftIcon={<Trash />} variant="outline-danger" size="sm">
          Remove {eligibleCount} target{suffix}
        </Button>
      </DialogTrigger>

      <DialogContent>
        <RemoveTargets
          selectedTargets={selectedProfiles}
          onBack={() => setIsOpen(false)}
          onSuccess={onRemoveSuccess}
          filters={filters}
        />
      </DialogContent>
    </Dialog>
  );
}
